import { NavLink } from "react-router";
import type { ReactNode } from "react";

import { ActivityIcon, CompaniesIcon, MapIcon, PlusIcon, ProfileIcon } from "../components/icons";
import { nl } from "../i18n/nl";
import styles from "./TabBar.module.css";

function Tab({ to, icon, label, end, badge }: { to: string; icon: ReactNode; label: string; end?: boolean; badge?: ReactNode }) {
  return (
    <NavLink to={to} end={end} className={({ isActive }) => (isActive ? styles.tabActive : styles.tab)}>
      {icon}
      {label}
      {badge}
    </NavLink>
  );
}

/** Mobile only (< 1024 px); hides itself on desktop. */
export function TabBar({ unreadCount = 0 }: { unreadCount?: number }) {
  return (
    <nav aria-label={nl.nav.main} className={styles.tabbar}>
      <Tab to="/" end icon={<CompaniesIcon size={22} />} label={nl.nav.companies} />
      <Tab to="/kaart" icon={<MapIcon size={22} />} label={nl.nav.map} />
      <NavLink to="/melden" aria-label={nl.nav.newReport} className={styles.plusLink}>
        <span className={styles.plus}>
          <PlusIcon size={20} />
        </span>
      </NavLink>
      <Tab
        to="/activiteit"
        icon={<ActivityIcon size={22} />}
        label={nl.nav.activity}
        badge={
          unreadCount > 0 && (
            <>
              <span className={styles.badge} aria-hidden="true">
                {unreadCount}
              </span>
              <span className="sr-only">{nl.nav.unread(unreadCount)}</span>
            </>
          )
        }
      />
      <Tab to="/profiel" icon={<ProfileIcon size={22} />} label={nl.nav.profile} />
    </nav>
  );
}
